module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel06_770_280_en-bd501b375f1599b8cf00adb0b1e02815.jpg";